import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { LostPasswordService, SmsAccount } from 'src/app/providers/lost-password.service';

@Component({
  standalone: false,
  selector: 'app-lost-password',
  templateUrl: './lost-password.component.html',
styleUrls:  ['./lost-password.component.css']
})
export class LostPasswordComponent extends SmsAbstractAppPage implements OnInit {

  username: any = "";
  email: any = "";
  submitted = false;

  recovery_method: 'email' | 'sms' = 'email';
  sms_step: 'phone' | 'otp' | 'pick-account' = 'phone';
  phone: string = '';
  otp: string = '';
  sms_pending: boolean = false;
  sms_accounts: SmsAccount[] = [];
  selection_token: string = '';

  constructor(private lostPasswordService: LostPasswordService, private router: Router) {
    super();
  }

  ngOnInit(): void {

  }

  handleSubmitRequest() {

    if(this.username == "" || this.email == "") {
      this.handleError("Please enter your username and email address");
      return;
    }

    this.lostPasswordService.submitRequest(this.username, this.email).then((response: any) => {
      this.submitted = true;
    }).catch(error => {
      this.handleError(error);
    });
  }

  handleSmsPhoneSubmit() {
    if (!this.phone || this.phone.trim() === '') {
      this.handleError('Please enter your phone number');
      return;
    }
    this.sms_pending = true;
    this.lostPasswordService.submitSmsRequest(this.phone.trim()).then(() => {
      this.sms_pending = false;
      this.sms_step = 'otp';
    }).catch(error => {
      this.sms_pending = false;
      this.handleError(error);
    });
  }

  handleOtpSubmit() {
    if (!this.otp || !/^\d{6}$/.test(this.otp.trim())) {
      this.handleError('Please enter the 6-digit code sent to your phone');
      return;
    }
    this.sms_pending = true;
    this.lostPasswordService.verifySmsOtp(this.phone.trim(), this.otp.trim()).then(response => {
      this.sms_pending = false;
      if (response.token) {
        this.router.navigate(['lost-password/make-change', response.token]);
      } else if (response.accounts && response.selection_token) {
        this.sms_accounts = response.accounts;
        this.selection_token = response.selection_token;
        this.sms_step = 'pick-account';
      }
    }).catch(error => {
      this.sms_pending = false;
      this.handleError(error);
    });
  }

  handleAccountSelect(user_id: string) {
    this.sms_pending = true;
    this.lostPasswordService.confirmSmsAccount(user_id, this.selection_token).then(response => {
      this.sms_pending = false;
      this.router.navigate(['lost-password/make-change', response.token]);
    }).catch(error => {
      this.sms_pending = false;
      this.handleError(error);
    });
  }
}
